// import ShareImg from '../assets/img/common/share.png'
import {
  getDeviceInfo,
  gethttpurl
  // QueryToJSON,
  // JsonToParams
} from './tools'
import { WxShare } from './wxShare'

// 设置分享
export function SetLeChengShare() {
  // const htmlPath = location.origin + location.pathname
  // const imgUrl = htmlPath.replace('index.html', ShareImg)
  const PlatInfo = getDeviceInfo()

  // const imgUrl = process.env.VUE_APP_BUILD_TARGET === 'prod' ? ShareImg : htmlPath.replace('index.html', ShareImg)
  const imgUrl =
    'https://static-cdn.yuanxinbaoxian.com/prod/images/xiangaibao/hunanhmb.png'
  // const PlatInfo = getDeviceInfo()

  if (PlatInfo.env === 'wechat') {
    // alert(gethttpurl('baosicode'))
    // const Query = QueryToJSON()
    // const searchStr = JsonToParams(Query)
    // const link =
    //   location.origin + location.pathname + searchStr + '#/area-insu-buy-detail'
    let jhb = gethttpurl('fromSourceCode')
      ? `?fromSourceCode=${gethttpurl('fromSourceCode')}`
      : '?fromSourceCode=qmhb'
    let productCode = gethttpurl('productCode')
      ? `&productCode=${gethttpurl('productCode')}`
      : ''
    let baosicode = gethttpurl('baosicode')
      ? `&baosicode=${gethttpurl('baosicode')}`
      : `&baosicode=${process.env.VUE_APP_BAOSICODE}`
    let thridUID = gethttpurl('thridUID')
      ? `&thridUID=${gethttpurl('thridUID')}`
      : ''
    const link =
      location.origin +
      location.pathname +
      jhb +
      productCode +
      baosicode +
      thridUID +
      '#/area-insu-buy-detail'
    WxShare({
      title: '湖南专属！139元保全年，最高300万医疗保障！',
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      desc: '医保内外都可报，涵盖院外特效药，不限年龄，老少同价'
    })
  }
}

// 企业预约页面分享
export function SetCompanyAppointmentShare() {
  // const htmlPath = location.origin + location.pathname
  // const imgUrl = process.env.VUE_APP_BUILD_TARGET === 'prod' ? ShareImg : htmlPath.replace('index.html', ShareImg)
  const imgUrl = 'https://static.baoxian72.com/img/hunanhmb.png'
  const PlatInfo = getDeviceInfo()

  if (PlatInfo.env === 'wechat') {
    // const Query = QueryToJSON()
    // const searchStr = JsonToParams(Query)
    // const link =
    //   location.origin + location.pathname + searchStr + '#/company-appointment'
    let jhb = gethttpurl('fromSourceCode')
      ? `?fromSourceCode=${gethttpurl('fromSourceCode')}`
      : '?fromSourceCode=qmhb'
    let productCode = gethttpurl('productCode')
      ? `&productCode=${gethttpurl('productCode')}`
      : ''
    let baosicode = gethttpurl('baosicode')
      ? `&baosicode=${gethttpurl('baosicode')}`
      : `&baosicode=${process.env.VUE_APP_BAOSICODE}`
    const link =
      location.origin +
      location.pathname +
      jhb +
      productCode +
      baosicode +
      '#/company-appointment'
    WxShare({
      title: '湖南专属！139元保全年，最高300万医疗保障！',
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      desc:
        '湖南医疗保障局指导值得信赖，参保人群无门槛，医保内外责任均包含，个账支付方便快捷！'
    })
  }
}
